export const REVIEWS_COLORS = {
  star5: "#826BFF",
  star4: "#9B90DA",
  star3: "#C4B5FD",
  star2: "#DDD6FE",
  star1: "#EDE9FE",
  postStay: "#C4B5FD",
  preCheckout: "#826BFF",
  purity: "#826BFF",
  comfort: "#9B90DA",
  service: "#CAC19F",
} as const;

export const REVIEWS_PAGE_SIZE = 7;

export const REVIEWS_RELATED_TABLE_ROW_HEIGHT = 72;
export const REVIEWS_RELATED_TABLE_FEEDBACK_WIDTH = 295;
export const REVIEWS_RELATED_TABLE_BORDER = "#E5E5E5";

export const REVIEWS_RELATED_TABLE_HEADER_CELL_CLASS =
  "h-10 border-b border-[#E5E5E5] p-2 text-center align-middle whitespace-nowrap";

export const REVIEWS_RELATED_TABLE_BODY_CELL_CLASS =
  "box-border overflow-hidden border-b border-[#E5E5E5] p-2 text-center align-middle";

export const REVIEWS_CATEGORY_CARD_WIDTH = 252;
export const REVIEWS_CATEGORY_CARD_HEIGHT = 396;
export const REVIEWS_CATEGORY_CARD_RADIUS = 16;
export const REVIEWS_CATEGORY_CARD_PADDING = 16;
export const REVIEWS_CATEGORY_CARD_BORDER = "#E5E5E5";

export const REVIEWS_CATEGORY_ROW_GAP = 8;
export const REVIEWS_CATEGORY_BAR_WIDTH = 140;
export const REVIEWS_CATEGORY_BAR_HEIGHT = 40;
export const REVIEWS_CATEGORY_BAR_RADIUS = 8;

export const REVIEWS_CATEGORY_BAR_TRACK_BG = "#E9E9E9";

export const REVIEWS_CATEGORY_BAR_FILL = "#CDC9BB";
export const REVIEWS_CATEGORY_BAR_FILL_OPACITY = 0.8;

export const REVIEWS_CATEGORY_LABELS: Record<
  "purity" | "comfort" | "service",
  string
> = {
  purity: "Purity",
  comfort: "Comfort",
  service: "Service",
};
